import React from 'react'
import { ContentStyles } from './ContentStyles'

interface ContentProperties {
    children: JSX.Element | JSX.Element[]
    responsive: boolean
}

export function ContentComponent(properties: ContentProperties) {
    return (
        <div
            style={{
                ...ContentStyles.container,
                width: properties.responsive ? '100%' : 'calc(100% - 300px)',
                position: 'relative',
            }}
        >
            {properties.children}
        </div>
    )
}
